<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ pharmacy.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PharmacyTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CButton color="primary" @click="addCategory">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.title">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" />
                                    </td>
                                    <td>{{ category.title }}</td>
                                    <td>
                                        <CButton @click="editCategory(category)">
                                            <CIcon :content="$options.icons.cilPencil" class="handle" />
                                        </CButton>
                                        <CButton @click="removeCategory(category)">
                                            <CIcon :content="$options.icons.cilTrash" class="handle" />
                                        </CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save">Сохранить порядок</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <PharmacyCategoryUpsertDialog
            ref="upsertDialog"
            :entity="selectedCategory"
            @success="fetch" />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks';
    import PharmacyCategoryUpsertDialog from '@/components/pharmacies/PharmacyCategoryUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'PharmacyCategories',

        components: {
            PharmacyTabLinks,
            draggable,
            PharmacyCategoryUpsertDialog,
            AppConfirmDialog,
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },

        data() {
            return {
                pharmacy: {
                    title: '',
                },
                categories: [],
                selectedCategory: {},
            };
        },

        computed: {},

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/pharmacies/' + id)
                    .then(resp => {
                        this.pharmacy = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get('/pharmacies/' + id + '/categories')
                    .then(resp => {
                        this.categories = resp.data.map(item => {
                            item.enabled = Boolean(item.enabled);
                            item.empty = Boolean(item.empty);
                            return item;
                        });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    categoriesToSave.push({
                        id: category.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post(
                        '/pharmacies/' + this.pharmacy.id + '/categories/reorder',
                        {
                            reorder: categoriesToSave,
                        }
                    )
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            addCategory() {
                this.selectedCategory = {
                    pharmacy_id: this.pharmacy.id,
                };
                this.$refs.upsertDialog.open();
            },

            editCategory(category) {
                this.selectedCategory = category;
                this.$refs.upsertDialog.open();
            },

            removeCategory(category) {
                this.selectedCategory = category;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedCategory.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(
                        `/pharmacies/${this.selectedCategory.pharmacy_id}/categories/${this.selectedCategory.id}`
                    )
                );

                if (error) {
                    return this.$root.$emit('showError', 'ошибка при удалении категории. ' + error);
                }

                await this.fetch();
            },

            goBack() {
                this.$router.push({ path: '/pharmacies/' + this.$route.params.id });
            },
        },
    };
</script>
<style scoped>
.handle {
    cursor: pointer;
}
</style>
